"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Skeleton = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var lab_1 = require("@material-ui/lab");
var classnames_1 = __importDefault(require("classnames"));
var Skeleton_style_1 = __importDefault(require("./Skeleton.style"));
var Skeleton = function (_a) {
    var className = _a.className, _b = _a.height, height = _b === void 0 ? 24 : _b, _c = _a.variant, variant = _c === void 0 ? 'rect' : _c, width = _a.width;
    var classes = (0, Skeleton_style_1.default)();
    return ((0, jsx_runtime_1.jsx)(lab_1.Skeleton, { className: (0, classnames_1.default)(variant !== 'circle' && classes.borderRadius, className), height: height, variant: variant, width: width, role: 'progressbar' }));
};
exports.Skeleton = Skeleton;
